import {DisplayAd} from '../../api/type.client';
import {DisplayAdVo} from '../../common/shared/api/gateway/DisplayAdVo.interface';

export function createDisplayAd({
  banner_uid: bannerUid,
  section_uid: sectionUid,
  moment_uid: momentUid,
  trevi_uid: treviUid,
}: DisplayAdVo): DisplayAd {
  return {
    bannerUid,
    sectionUid,
    momentUid,
    treviUid,
  };
}
